import { Entity } from 'src/app/modules/portfolio/models/entity';
import { CreateEntityRequest } from 'src/app/web-api-client';

export const mapEntityToCreateRequest = (
  entity: Entity
): CreateEntityRequest => {
  return new CreateEntityRequest({
    clientId: entity.clientId,
    residencyJurisdictionId:
      entity.residencyJurisdiction?.residencyJurisdictionId,
    entityTypeId: entity.entityType?.entityTypeId,
    name: entity.name ?? '',
    description: entity.description ?? '',
    isActive: entity.isActive ?? true,
  });
};
